/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_R2_Upload_PathInputs */

const en_admin_settings_fields_r2_upload_path = /** @type {(inputs: Admin_Settings_Fields_R2_Upload_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload Path`)
};

const zh_admin_settings_fields_r2_upload_path = /** @type {(inputs: Admin_Settings_Fields_R2_Upload_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上传路径`)
};

/**
* | output |
* | --- |
* | "Upload Path" |
*
* @param {Admin_Settings_Fields_R2_Upload_PathInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_r2_upload_path = /** @type {((inputs?: Admin_Settings_Fields_R2_Upload_PathInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_R2_Upload_PathInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_fields_r2_upload_path(inputs)
	return zh_admin_settings_fields_r2_upload_path(inputs)
});
export { admin_settings_fields_r2_upload_path as "admin.settings.fields.r2_upload_path" }